



















































































































































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {LadingStore} from "../../../store";
import InputCurrency from "@/shared/components/InputCurrency/index.vue";

@Component({
    name: "InfoPaymentLading",
    components: {InputCurrency}
})
export default class extends mixins(CommonMixin){
    @Prop() readonly ladingRowGuid!: string;
    inputSize = 'small';

    get lading() {
        return LadingStore.data[this.ladingRowGuid];
    }
}
